import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b823ee9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lading-bill"
}
const _hoisted_2 = { class: "form-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "form-table-td-count" }, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_4 = { colspan: "10" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "附件", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_order_form_company_business_card = _resolveComponent("order-form-company-business-card")!
  const _component_order_form_products_summary = _resolveComponent("order-form-products-summary")!
  const _component_order_form_container = _resolveComponent("order-form-container")!
  const _component_order_form_lading_bill = _resolveComponent("order-form-lading-bill")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!
  const _component_company_business_card_form = _resolveComponent("company-business-card-form")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_miezz_card, {
      ref: "ref-card",
      fix: true,
      title: "分单信息",
      "bottom-buttons": _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
          type: "card",
          "tab-position": "top",
          style: {"width":"calc(100% - 20px)"},
          onTabClick: _ctx.handleTabClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: item.Id,
                name: item.Id
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(`${item.Pool?.ClientCompanyNameZh}/${item.Pool?.BookingNo}`), 1),
                  (item.Pool?.DeparturePortLadingBill)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Warning)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onTabClick"]),
        (_ctx.form.Data)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              model: _ctx.form.Data,
              ref: "ruleForm",
              rules: _ctx.form.Rules,
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_2, [
                  _hoisted_3,
                  (_openBlock(), _createBlock(_component_order_form_company_business_card, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form) = $event)),
                    key: _ctx.id,
                    red: _ctx.addDeparturePortBookingPartBill
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "Booking No.",
                        prop: "BookingNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.detail.Pool.BookingNo,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.Pool.BookingNo) = $event)),
                            disabled: true,
                            red: _ctx.addDeparturePortBookingPartBill
                          }, null, 8, ["modelValue", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of  Loading/装货港",
                        prop: "LoadingPortId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.LoadingPortId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.LoadingPortId) = $event)),
                            label: _ctx.form.Data.LoadingPortLabel,
                            "onUpdate:label": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.LoadingPortLabel) = $event)),
                            options: _ctx.loadingPorts,
                            remote: true,
                            remoteMethod: _ctx.getLoadingPorts,
                            red: _ctx.addDeparturePortBookingPartBill,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加'
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Discharge/卸货港",
                        prop: "DischargePortId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.DischargePortId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.DischargePortId) = $event)),
                            label: _ctx.form.Data.DischargePortLabel,
                            "onUpdate:label": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.DischargePortLabel) = $event)),
                            options: _ctx.dischargePorts,
                            remote: true,
                            remoteMethod: _ctx.getDischargePorts,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加'
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Port of Delivery/目的港",
                        prop: "DeliveryPortId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.DeliveryPortId,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.Data.DeliveryPortId) = $event)),
                            label: _ctx.form.Data.DeliveryPortLabel,
                            "onUpdate:label": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.DeliveryPortLabel) = $event)),
                            options: _ctx.deliveryPorts,
                            remote: true,
                            remoteMethod: _ctx.getDeliveryPorts,
                            red: _ctx.addDeparturePortBookingPartBill,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加'
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "Place of Delivery/交货地点",
                        prop: "DeliveryPlaceLabel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.DeliveryPlaceLabel,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Data.DeliveryPlaceLabel) = $event)),
                            "fetch-suggestions": _ctx.getDeliveryPlaces,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName"
                          }, null, 8, ["modelValue", "fetch-suggestions"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "承运人",
                        prop: "CarrierId"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.CarrierId,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Data.CarrierId) = $event)),
                            label: _ctx.form.Data.CarrierLabel,
                            "onUpdate:label": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.Data.CarrierLabel) = $event)),
                            options: _ctx.carriers,
                            remote: true,
                            placeholder: '请填写关键词',
                            noDataText: '无匹配数据，请至参数管理中添加',
                            remoteMethod: _ctx.getCarriers,
                            onVisibleChange: _cache[11] || (_cache[11] = 
                  (s) => {
                    if (s) _ctx.getCarriers();
                  }
                )
                          }, null, 8, ["modelValue", "label", "options", "remoteMethod"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "合约号",
                        prop: "ContractNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.ContractNo,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.Data.ContractNo) = $event)),
                            upperCase: true,
                            trimAll: true
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "船名",
                            prop: "ShipName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.ShipName,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.Data.ShipName) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Sea)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "航次",
                            prop: "VoyageNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.VoyageNumber,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.Data.VoyageNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Air)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 2,
                            label: "航班",
                            prop: "Flight"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.Flight,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.Data.Flight) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail?.TransportType == _ctx.EnumTransportType.Railway)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 3,
                            label: "班次",
                            prop: "RailwayNumber"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_miezz_input, {
                                modelValue: _ctx.form.Data.RailwayNumber,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.Data.RailwayNumber) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ETD",
                        prop: "EstimatedDepartureDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedDepartureDate,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.Data.EstimatedDepartureDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "装货港ATD",
                        prop: "ActualDepartureDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.ActualDepartureDate,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.Data.ActualDepartureDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ETA",
                        prop: "EstimatedArrivalDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.EstimatedArrivalDate,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.Data.EstimatedArrivalDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "目的港ATA",
                        prop: "ActualArrivalDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.form.Data.ActualArrivalDate,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.Data.ActualArrivalDate) = $event)),
                            type: "datetime",
                            format: "YYYY/MM/DD HH:mm",
                            "value-format": "YYYY/MM/DD HH:mm",
                            class: "form-item-date"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "挂靠码头",
                        prop: "Dock"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_input, {
                            modelValue: _ctx.form.Data.Dock,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.Data.Dock) = $event)),
                            "fetch-suggestions": _ctx.getDeliveryPlaces,
                            "trigger-on-focus": true,
                            clearable: "",
                            valueKey: "FullName"
                          }, null, 8, ["modelValue", "fetch-suggestions"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运费支付方式",
                        prop: "TransportPaymentType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.TransportPaymentType,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.Data.TransportPaymentType) = $event)),
                            options: _ctx.EnumTransportPaymentTypeOption,
                            red: _ctx.addDeparturePortBookingPartBill
                          }, null, 8, ["modelValue", "options", "red"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "运输类型",
                        prop: "GoodsTransportType"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.form.Data.GoodsTransportType,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.Data.GoodsTransportType) = $event)),
                            options: _ctx.EnumGoodsTransportTypeOption
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["form", "red"])),
                  _createVNode(_component_order_form_products_summary, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form) = $event)),
                    reds: 
            _ctx.addDeparturePortBookingPartBill
              ? [
                  'MarksNotes',
                  'PackagesNumber',
                  'PackagesKind',
                  'GoodsDescription',
                  'GrossWeight',
                  'Volume',
                ]
              : []
          
                  }, null, 8, ["form", "reds"]),
                  (
            _ctx.detail?.Pool?.TransportContainerLoad ==
            _ctx.EnumTransportContainerLoad.FCL
          )
                    ? (_openBlock(), _createBlock(_component_order_form_container, {
                        key: 0,
                        form: _ctx.form,
                        "onUpdate:form": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form) = $event)),
                        disabledAdd: _ctx.detail?.StowageOrder,
                        disabledQuantity: _ctx.detail?.StowageOrder,
                        showSealNumbers: 
            _ctx.detail?.TransportContainerLoad == _ctx.EnumTransportContainerLoad.FCL
          ,
                        departurePortContainer: _ctx.detail?.OpenDeparturePortContainer,
                        orderId: _ctx.detail.OrderId
                      }, null, 8, ["form", "disabledAdd", "disabledQuantity", "showSealNumbers", "departurePortContainer", "orderId"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_order_form_lading_bill, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form) = $event)),
                    reds: _ctx.addDeparturePortBookingPartBill ? ['LadingBillType'] : [],
                    requireds: ['LadingBillType']
                  }, null, 8, ["form", "reds"])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", null, [
                      _createVNode(_component_miezz_upload, {
                        modelValue: _ctx.form.Data.Files,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.Data.Files) = $event)),
                        path: "order/part-bill",
                        prop: "File",
                        maxSize: 2 * 1024 * 1024
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["bottom-buttons", "onHandleFooterButtonClick"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalBusinessCard,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.modalBusinessCard) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_company_business_card_form, {
          modelValue: _ctx.modalBusinessCard,
          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.modalBusinessCard) = $event)),
          id: _ctx.businessCardId,
          companyId: _ctx.detail?.Pool?.ClientCompanyId,
          parentId: _ctx.businessCardParentId,
          area: _ctx.businessCardArea,
          type: _ctx.businessCardType,
          content: _ctx.businessCardContent,
          onHandleSubmit: _ctx.handleSubmitBusinessCard
        }, null, 8, ["modelValue", "id", "companyId", "parentId", "area", "type", "content", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}